import { useAuth } from "./AuthProvider";

/**
 * Sign out within the admin application, clearing this tab's Cognito session.
 */
export function useLogout(): () => Promise<void> {
  const auth = useAuth();
  return auth.controller.signOut;
}
